import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'


type GLTFResult = GLTF & {
  nodes: {}
  materials: {}
}

export function GroupBody() {
    const { nodes, materials, animations } = useGLTF('objects/group-body.gltf') as GLTFResult
    return animations
}

useGLTF.preload('objects/group-body.gltf')